<template>
  <button
    type="button"
    class="btn-plain"
    :class="[
      favorite ? 'btn-heart-fill' : 'btn-heart',
      fromSearchBar ? 'custom- mt-2' : '',
    ]"
    :disabled="toggledisabled"
  >
    <!-- New bookmark SVG for SearchBar -->
    <svg
      v-if="fromSearchBar"
      width="23"
      height="29"
      viewBox="0 0 23 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="bookmark-svg"
      :class="{ 'favorite-active': favorite }"
    >
      <path
        d="M2 1.5H21C21.2761 1.5 21.5 1.72386 21.5 2V26.3076C21.5 26.78 20.9058 26.9887 20.6104 26.6201L13.4502 17.6904L13.3545 17.5771C12.3652 16.4795 10.6348 16.4795 9.64551 17.5771L9.5498 17.6904L2.38965 26.6201C2.09418 26.9887 1.5 26.78 1.5 26.3076V2C1.5 1.72386 1.72386 1.5 2 1.5Z"
        :fill="favorite ? '#f08080' : 'white'"
        :stroke="favorite ? '#f08080' : 'black'"
        stroke-width="3"
      />
    </svg>
    
    <!-- Original bookmark SVG for other places -->
    <svg
      v-else
      width="20"
      viewBox="0 0 18 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="bookmark-svg"
      :class="{ 'favorite-active': favorite }"
    >
      <path
        d="M2.52344 0.5H15.0947C15.9232 0.5 16.5947 1.17157 16.5947 2V23.5381C16.5946 24.9665 14.8075 25.5642 13.9385 24.4941L13.8574 24.3857L10.0469 18.8193C9.48822 18.0034 8.32443 17.9527 7.69043 18.667L7.57129 18.8193L3.76074 24.3857C2.9276 25.6018 1.02355 25.0124 1.02344 23.5381V2C1.02344 1.17157 1.69501 0.5 2.52344 0.5Z"
        :fill="favorite ? '#f08080' : 'white'"
        :stroke="favorite ? '#f08080' : '#787878'"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'Favorite',
  props: ['favorite', 'toggledisabled', 'fromSearchBar'],
};
</script>

<style scoped>
.btn-plain.custom-size {
  margin-top: 10px;
}

.bookmark-svg {
  transition: all 0.2s ease;
  height: 30px; /* Increased from 27px to 30px */
}

.bookmark-svg.favorite-active {
  filter: brightness(0.9);
}

.custom-size .bookmark-svg {
  transform: scale(1.2);
}

.prof-head-left .btn-heart:hover .bookmark-svg,
.one-right .btn-heart:hover .bookmark-svg {
  filter: brightness(0.8);
}

.prof-head-left .btn-heart-fill:hover .bookmark-svg,
.one-right .btn-heart-fill:hover .bookmark-svg {
  filter: brightness(0.7);
}
</style>
